import PremiumNavbar from "../components/premium/PremiumNavbar";
import PremiumFooter from "../components/premium/PremiumFooter";
import HomePage from "../Pages/HomePage";
import BackToTop from "../components/BackToTop";
import ScrollToTop from "../Pages/ScrollToTop";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Enrollment from "../Pages/Enrollment";
import FAQ from "../Pages/FAQ";
import PrivacyPolicy from "../Pages/PrivacyPolicy";
import TermsConditions from "../Pages/TermsConditions";
import HappyRide from "../Pages/HappyRide";
import AboutPage from "../Pages/premium/AboutPage";
import ProductsPage from "../Pages/premium/ProductsPage";
import ServicesPage from "../Pages/premium/ServicesPage";
import LaunchEventPage from "../Pages/premium/LaunchEventPage";
import ContactPage from "../Pages/premium/ContactPage";
import RudraRidePage from "../Pages/premium/RudraRidePage";
import EduPravahaaPage from "../Pages/premium/EduPravahaaPage";

function Routers() {
  return (
    <Router>
      <PremiumNavbar />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/About" element={<Navigate to="/about" replace />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/Services" element={<Navigate to="/services" replace />} />
        <Route path="/launch-event" element={<LaunchEventPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/contactus" element={<Navigate to="/contact" replace />} />
        <Route path="/enroll" element={<Enrollment />} />
        <Route path="/edupravahaa" element={<EduPravahaaPage />} />
        <Route path="/rudra-rides" element={<RudraRidePage />} />
        <Route path="/HappyRide" element={<HappyRide />} />
        <Route path="/FAQ" element={<FAQ />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/TermsConditions" element={<TermsConditions />} />
      </Routes>
      <PremiumFooter />
      <BackToTop />
    </Router>
  );
}

export default Routers;
